import React from 'react';
import PropTypes from 'prop-types';
import { tableHeaderSort } from '../helpers/TableHelpers';

const TABLE_HEADER = {
  'created_at': 'Date',
}

export default class AccountPlayerPlaysHeader extends React.Component {
  static propTypes = {
    id: PropTypes.number.isRequired,
    meta: PropTypes.object.isRequired,
    onSortChange: PropTypes.func.isRequired,
  }

  onSortChange = (e) => {
    const sort = e.target.dataset.sort;
    const order = this.props.meta.order || 'asc';
    const newOrder = order === 'desc' ? 'asc' : 'desc';
    this.props.onSortChange(this.props.id, sort, newOrder);
  }

  render() {
    const { meta } = this.props;
    return (
      <thead>
        <tr>
          <th>Playpack</th>
          <th>Card</th>
          { tableHeaderSort('created_at', meta, TABLE_HEADER, this.onSortChange) }
          <th>Feedback Liked</th>
          <th>Feedback Level</th>
          <th>Feedback</th>
        </tr>
      </thead>
    );
  }
}
